import NewsTipMediaList from './NewsTipMediaList'

export default NewsTipMediaList
